module.exports = __webpack_public_path__ + "img/76_19.d449a563.png";